import createAPI from '../axios'
import config from "../../views/siteManage/config.vue";

//基础信息相关API

const dataSummary = {
    adultEducation: {
        initCombo: config => createAPI('/dataSummary/adultEducation/initCombo', 'post', config),
        queryList: config => createAPI('/dataSummary/adultEducation/queryList', 'post', config),
    },
    skillsTraining: {
        initCombo: config => createAPI('/dataSummary/skillsTraining/initCombo', 'post', config),
        querySchoolEnterpriseCooperationList: config => createAPI('/dataSummary/skillsTraining/querySchoolEnterpriseCooperationList', 'post', config),
        schoolEnterpriseCooperation: config => createAPI('/dataSummary/skillsTraining/schoolEnterpriseCooperation', 'post', config),
        querySkillsTrainingList: config => createAPI('/dataSummary/skillsTraining/querySkillsTrainingList', 'post', config),
    },
    SkillRecognition: {
        queryList: config => createAPI('/dataSummary/SkillRecognition/queryList', 'post', config),
    },
    schoolEnterpriseCooperation: {
        queryList: config => createAPI('/dataSummary/schoolEnterpriseCooperation/queryList', 'post', config),
        initCombo: config => createAPI('/dataSummary/schoolEnterpriseCooperation/initCombo', 'post', config),
        save: config => createAPI('/dataSummary/schoolEnterpriseCooperation/save', 'post', config),
        deleteById: config => createAPI('/dataSummary/schoolEnterpriseCooperation/deleteById', 'post', config),
        drxqhz: config => createAPI('/dataSummary/schoolEnterpriseCooperation/drxqhz', 'post', config),
        batchExport: config => createAPI('/dataSummary/schoolEnterpriseCooperation/batchExport', 'post', config),
    },
};

export default dataSummary;



// WEBPACK FOOTER //
// ./src/api/modules/dataSummary.js